/* jshint esversion: 6 */
module.exports = {
	development: {
		baseUrl: 'http://client.voyej.test',
		apiUrl: 'http://voyej.test/api/v1',
		apiBaseUrl: 'http://voyej.test',
		midtrans: {
			client_key: 'VT-client-uQnBhvacXiyEbFBR'
			// client_key: 'VT-client-IXR9xdybkl8pqC-L'
		}
	},
	production: {
		baseUrl: 'https://beta-v2.voyejstore.com',
		apiUrl: 'https://api.voyejstore.com/api/v1',
		apiBaseUrl: 'https://api.voyejstore.com',
		midtrans: {
			client_key: 'VT-client-uQnBhvacXiyEbFBR'
			// client_key: 'VT-client-IXR9xdybkl8pqC-L'
		}

	}
}[process.env.NODE_ENV || 'development'];


// WEBPACK FOOTER //
// ./src/config/app.js